import React from 'react';

export interface ICSSLayoutProps {
  // Selects the autoflow method: 'row' or 'dense' (default). 'row' uses a sparse layout method, where 'dense' will attempt to fill any empty space.
  autoFlow?: 'dense' | 'row';
  // The base row height to use in order to keep all items in a row the same height. Defaults to 240.
  baseRowHeight?: number;
  // The number of columns to use in the grid. Defaults to 3.
  columns?: number;
  // The children of this component.
  children: any;
}

export const CSSLayout = ({
  autoFlow = 'dense',
  baseRowHeight = 240,
  children,
  columns = 3
}: ICSSLayoutProps) => {
  const styles = {
    gridAutoRows: `minmax(${baseRowHeight}px, auto)`,
    gridAutoFlow: autoFlow
  };

  const className = `mdf-css-layout grid grid-cols-${columns} gap-2`;

  return (
    <div className={className} style={styles}>
      {children}
    </div>
  );
};

CSSLayout.displayName = 'CSSLayout';

export interface ICSSLayoutItemProps {
  // The children of this component.
  children: any;
  // The number of columns this item should span in the layout. Defaults to 1.
  colSpan?: number;
  // The specific column in which to put this item. Columns are 1-based.
  gridColumn?: string;
  // The specific row in which to put this item. Rows are 1-based.
  gridRow?: string;
  // The number of rows this item should span in the layout. Defaults to 1.
  rowSpan?: number;
}

export const CSSLayoutItem = ({
  children,
  colSpan = 1,
  gridColumn,
  gridRow,
  rowSpan = 1
}: ICSSLayoutItemProps) => {
  const classNames = `mdf-css-layout-item flex col-span-${colSpan} row-span-${rowSpan}`;

  const styles: any = {};

  if (gridColumn) {
    styles.gridColumn = gridColumn;
  }

  if (gridRow) {
    styles.gridRow = gridRow;
  }

  return (
    <div className={classNames} style={styles}>
      {children}
    </div>
  );
};

CSSLayoutItem.displayName = 'CSSLayoutItem';
